"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownMenuOption = exports.Wrapper = exports.Content = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e3ttgez1"
} : {
  target: "e3ttgez1",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1ivkyd7",
  styles: "position:relative;display:flex;flex-direction:row;&>svg{margin-left:0.5em;}"
} : {
  name: "1ivkyd7",
  styles: "position:relative;display:flex;flex-direction:row;&>svg{margin-left:0.5em;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Content = exports.Content = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e3ttgez0"
} : {
  target: "e3ttgez0",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "1hctxho",
  styles: "position:absolute;background-color:white;right:0;top:30px;box-sizing:border-box;min-width:230px;border:1px solid #cfd9ea;background-color:#ffffff;box-shadow:0 10px 15px 0 rgba(0, 0, 0, 0.1);border-radius:10px;overflow:hidden;z-index:1001"
} : {
  name: "1hctxho",
  styles: "position:absolute;background-color:white;right:0;top:30px;box-sizing:border-box;min-width:230px;border:1px solid #cfd9ea;background-color:#ffffff;box-shadow:0 10px 15px 0 rgba(0, 0, 0, 0.1);border-radius:10px;overflow:hidden;z-index:1001",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const dropdownMenuOption = theme => /*#__PURE__*/(0, _react.css)("width:100%;height:52px;background-color:white;border-radius:0;font-weight:500;border-top:1px solid ", theme.border, ";cursor:pointer;font-weight:600;&:hover{background:", theme.bg, ";}&:nth-of-type(1){border-top:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownMenuOption;"));
exports.dropdownMenuOption = dropdownMenuOption;